const ACTIONS = {
    CALENDAR_HEADER_TOGGLE: 'calendar-header-toggle',
    DESIGNER_HEADER_TOGGLE: 'designer-header-toggle',
    NAV_SET_PATH: 'nav-set-path'
};

export default ACTIONS;
